import { toStringify } from '../utils/smartutils';

export function accountListByFilter(id) {
  const query = `{
    accountListByFilter(
      filter: {
        filterByStatus: false,
        active: true,
        updaterId: 0,
        checkingAccount: false,
        id: ${id || 0},
        integrateIfIugu: false,
        smartpay: false,
        defaultAccount: false,
        extraWithdrawalAmount: 0,
        numberWithdrawals: 0,
      }
    ) {
      id
      name
      description
      agency
      accountNumber
      type
      ownerIdentifier
      ownerType
      active
      defaultAccount
      bank {
        id
        name
        agencyPattern
        accountPattern
        active
      }      
      filterByStatus
      updaterId
      checkingAccount
      integrateIfIugu
      smartpay
      extraWithdrawalAmount
      numberWithdrawals
      iuguAccountInfo {
        iuguId
        iuguAccountName
        iuguLiveToken
        iuguTestToken
        userToken
        cnpj
        companyName
        address
        addressNumber
        cep
        state {
          id
          name
          uf
        }
        city {
          id
          name
          ibgeId
          stateId
        }
        telephone
        respName
        respCpf
        bank {
          id
          name
          agencyPattern
          accountPattern
          filterByStatus,
          updaterId
          active
        }
        bankAgency
        banckCc
        accountType
        useBankSlip
        bankSlipCommission
        verificationStatus
        interestForDelay
        dailyInterestForDelay
        interestRateForDelay
        balanceAvailableForWithdraw
        autoWithDraw
      }
    }
  }
  `;
  return query;
}

export function accountListByFilterObject(filter) {
  const query = `{
    accountListByFilter(
      filter: {
        filterByStatus: ${!!filter.filterByStatus},
        active: ${!!filter.active},
        updaterId: 0,
        checkingAccount: ${!!filter.checkingAccount},
        id: ${filter.id || 0},
        integrateIfIugu: ${!!filter.integrateIfIugu},
        smartpay: ${!!filter.smartpay},
        defaultAccount: ${!!filter.defaultAccount},
        extraWithdrawalAmount: 0,
        numberWithdrawals: 0,
      }
    ) {
      id
      name
      description
      agency
      accountNumber
      type
      ownerIdentifier
      ownerType
      active
      defaultAccount
      bank {
        id
        name
        agencyPattern
        accountPattern
        active
      }      
      filterByStatus
      updaterId
      checkingAccount
      integrateIfIugu
      smartpay
      extraWithdrawalAmount
      numberWithdrawals
      iuguAccountInfo {
        iuguId
        iuguAccountName
        iuguLiveToken
        iuguTestToken
        userToken
        cnpj
        companyName
        address
        addressNumber
        cep
        state {
          id
          name
          uf
        }
        city {
          id
          name
          ibgeId
          stateId
        }
        telephone
        respName
        respCpf
        bank {
          id
          name
          agencyPattern
          accountPattern
          filterByStatus,
          updaterId
          active
        }
        bankAgency
        banckCc
        accountType
        useBankSlip
        bankSlipCommission
        verificationStatus
        interestForDelay
        dailyInterestForDelay
        interestRateForDelay
        balanceAvailableForWithdraw
        autoWithDraw
      }
    }
  }
  `;
  return query;
}

export function removeAccountMutation(id) {
  const query = `mutation {accountRemove(id: ${id})}`;
  return query;
}

export function bankListByFilter(filter) {
  const query = `{bankListByFilter(filter:  ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) {id, name, agencyPattern, accountPattern, active}}`;
  return query;
}

export function discountConfigurationByAccount(account) {
  const query = `{
    discountConfigurationByAccount(accountId: ${account}) {
      id
      accountId
      daysBeforeExpiration
      discountPercentage
    }
  }
  `;
  return query;
}

export function alertDayAccountAvailable(accountId) {
  const query = `{
    alertDayAccountAvailable(accountId: ${accountId || 0}) {
      accountId
      alertDay
      descriptionAlertDay
    }
  }  
  `;
  return query;
}

export function alertDayByAccount(accountId) {
  const query = `{
    alertDayByAccount(accountId: ${accountId || 0}) {
      accountId
      alertDay
      descriptionAlertDay
    }
  }  
  `;
  return query;
}

export function alertDayAccountSaveMutation(accountId, list) {
  const mutation = `mutation {
    alertDayAccountSave(
      accountId: ${accountId}
      alertsDay: ${JSON.stringify(list).replace(/"([^(")"]+)":/g, '$1:')}
    )
  }
  `;
  return mutation;
}

export function applyDiscountConfigurationMutation(accountId, list) {
  const mutation = `mutation {
    applyDiscountConfiguration(
      accountId: ${accountId}
      discountsConfiguration: ${JSON.stringify(list).replace(
        /"([^(")"]+)":/g,
        '$1:'
      )}
    )
  }
  `;
  return mutation;
}

export function accountSaveMutation(values) {
  const bank = {
    id: values.checkingAccount || values.smartpay ? values.bank.id : null,
    name: values.checkingAccount || values.smartpay ? values.bank.name : null,
    agencyPattern:
      values.checkingAccount || values.smartpay
        ? values.bank.agencyPattern
        : null,
    accountPattern:
      values.checkingAccount || values.smartpay
        ? values.bank.accountPattern
        : null,
    active:
      values.checkingAccount || values.smartpay ? values.bank.active : false,
    filterByStatus: false,
    updaterId: 0,
  };

  const iuguAccountInfo = values.smartpay
    ? {
        accountId: values.id,
        iuguId: values.iuguId || '',
        iuguAccountName: values.iuguAccountName || '',
        iuguLiveToken: values.iuguLiveToken || '',
        iuguTestToken: values.iuguTestToken || '',
        userToken: values.userToken || '',
        cnpj: values.cnpj,
        companyName: values.companyName,
        address: values.address,
        addressNumber: values.addressNumber,
        cep: values.zipCode,
        state: {
          id: values.state.id,
          name: values.state.name,
          uf: values.state.uf,
        },
        city: {
          id: values.city.id,
          name: values.city.name,
          ibgeId: values.city.ibgeId,
          stateId: values.city.stateId,
        },
        telephone: values.phone,
        respName: values.respName,
        respCpf: values.respCpf,
        bank: {
          id: values.bank.id,
          name: values.bank.name,
          agencyPattern: values.bank.agencyPattern,
          accountPattern: values.bank.accountPattern,
          filterByStatus: false,
          updaterId: 0,
          active: values.bank.active,
        },
        bankAgency: values.bankAgency,
        banckCc: values.banckCc,
        accountType: values.accountType,
        useBankSlip: values.useBankSlip || true,
        bankSlipCommission: values.bankSlipCommission
          ? parseInt(values.bankSlipCommission, 10)
          : 0,
        verificationStatus: values.verificationStatus,
        interestForDelay: values.interestForDelay,
        dailyInterestForDelay: values.dailyInterestForDelay,
        interestRateForDelay: parseInt(values.interestRateForDelay, 10),
        balanceAvailableForWithdraw: values.balanceAvailableForWithdraw,
        autoWithDraw: values.autoWithDraw,
      }
    : null;
  const mutationQuery = `mutation { 
        accountSave(account: {
            id: ${values.id || 0}
            name: "${values.name}"
            description: "${values.description || ''}"
            agency: "${values.agency || ''}"
            accountNumber: "${values.accountNumber || ''}"
            type: "${values.type || ''}"
            ownerIdentifier: "${values.ownerIdentifier || ''}"
            ownerType: "${values.ownerType || ''}"
            active: ${values.active}
            defaultAccount: ${values.defaultAccount}
            checkingAccount: ${values.checkingAccount}
            integrateIfIugu: ${values.integrateIfIugu || false}
            smartpay: ${values.smartpay || false}
            bank: ${JSON.stringify(bank).replace(/"([^(")"]+)":/g, '$1:')}
            filterByStatus: ${values.filterByStatus || false}
            updaterId: ${values.updaterId || 0}
            extraWithdrawalAmount: ${
              !values.autoWithDraw
                ? parseFloat(values.extraWithdrawalAmount)
                : 0
            }
            numberWithdrawals: ${
              !values.autoWithDraw ? parseInt(values.numberWithdrawals, 10) : 0
            }
            iuguAccountInfo: ${
              values.smartpay
                ? JSON.stringify(iuguAccountInfo).replace(
                    /"([^(")"]+)":/g,
                    '$1:'
                  )
                : null
            } 
          }){id}
    }`;
  return mutationQuery;
}

export function accountListByFilterForField(filter) {
  return `{
    accountListByFilter(
      filter: ${toStringify(filter)}
    ) {
      id
      value
      label
    }
  }`;
}
